export const TwoFactorSceneTranslation = {
  fi: {
    TwoFactorScene: {
      '2faActivated': 'Kaksivaiheinen tunnistautuminen aktivoitu',
      '2faDisabled': 'Kaksivaiheinen tunnistautuminen poistettu käytöstä',
      invalidTokenLength: 'Vahvistuskoodin tulee olla 6 numeroa',
      passwordRequired: 'Salasana vaaditaan',
      enable2fa: 'Ota kaksivaiheinen tunnistautuminen käyttöön',
      '2faDescription':
        'Kaksivaiheinen tunnistautuminen lisää turvallisuutta vaatimalla koodin älypuhelimestasi sisäänkirjautumisen yhteydessä.',
      enable2faButton: 'Ota käyttöön',
      scanQrCode: 'Skannaa QR-koodi',
      orEnterManually: 'Tai syötä koodi manuaalisesti:',
      verificationCode: 'Vahvistuskoodi',
      activate: 'Aktivoi',
      '2faIsActive': 'Kaksivaiheinen tunnistautuminen on aktiivinen',
      '2faActiveDescription': 'Tilisi on suojattu kaksivaiheisella tunnistautumisella.',
      disable2fa: 'Poista käytöstä',
      confirmDisable2fa: 'Haluatko varmasti poistaa kaksivaiheisen tunnistautumisen?',
      enterPasswordToDisable:
        'Vahvista salasana poistaaksesi kaksivaiheisen tunnistautumisen:',
      password: 'Salasana',
      cancel: 'Peruuta',
      disable: 'Poista käytöstä',
    },
  },
};
